import React from 'react'

function About_us() {
  return (
    <div className='About_US_SULUHU'>
        <p className='About_us_p'>About Us</p>

        <p className='About_us_SUB'>Who We Are:</p>
        <div className='about_us_description'>
        "Suluhu is a student-focused eCommerce platform providing affordable, 
         high-quality essentials for university life. From bedding to stationery, we make student living easier."
        </div>

        <p className='About_us_SUB'>Our Mission:</p>
        <div className='about_us_description'>
        To provide students with affordable, high-quality products that simplify campus life
        </div>

        <p className='About_us_SUB'>Our Vision:</p>
        <div className='about_us_description'>
        To be the leading student essentials provider in Kenya, offering convenience, affordability, and quality."
        </div>

        <p className='About_us_SUB'>Our Core Values:</p>
        <div className='about_us_description'>
        •	Affordability – Budget-friendly solutions.
•	Convenience – Fast and easy ordering.
•	Quality – Trusted suppliers.
•	Student Support – Helping students succeed.

        </div>

        <p className='About_us_SUB'>Sustainability & Ethics:</p>
        <div className='about_us_description'>
        •	Ethical sourcing, eco-friendly packaging, student community initiatives
        </div>
    </div>
  )
}

export default About_us